module.exports = __webpack_public_path__ + "static/media/7362.4b6afd73.png";